/** Request permission and get video stream */
export const getWebCamStream = (): Promise<MediaStream> =>
  navigator.mediaDevices.getUserMedia({
    audio: false,
    video: {
      // width: 1280,
      // height: 720,
      facingMode: 'environment', // Rear facing camera
    },
  });

// export async function hasVideoPermission(): Promise<boolean> {
//   // Check if the browser supports navigator.mediaDevices
//   if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
//     // Enumerate devices
//     return navigator.mediaDevices
//       .enumerateDevices()
//       .then(devices => {
//         // Filter only video input devices (cameras)
//         const videoInputs = devices.filter(
//           device => device.kind === 'videoinput'
//         );
//         // Check permissions for each camera
//         return videoInputs.some(camera => {
//           console.log(`Camera ${camera.label || camera.deviceId}`);
//           console.log(
//             `Permission Granted: ${camera.label ? 'Yes' : 'Unknown'}`
//           );
//           return !!camera.label;
//         });
//       })
//       .catch(error => {
//         console.error('Error enumerating devices:', error);
//         return false;
//       });
//   }
//   console.error('navigator.mediaDevices.enumerateDevices not supported');
//   return false;
// }
